module.exports = __webpack_public_path__ + "img/frag_img1.ad868bf6.gif";